export default __webpack_public_path__ + "static/media/README.3569d574.md";